import { FabricContext } from '@context/FabricContext';
import { useSelectedMVComment } from '@hooks';
import { useContext, useEffect, useCallback, useState } from 'react';

export default function useHasAnnotations() {
  const selectedComment = useSelectedMVComment();
  const { canvas, getObjects } = useContext(FabricContext);
  const [has, setHas] = useState<boolean>(false);

  const hasObjects = useCallback(() => {
    const objects = getObjects();
    setHas(objects.length > 0);
  }, [getObjects]);

  useEffect(() => {
    setHas(!!selectedComment?.annotations?.length);
  }, [setHas, selectedComment]);

  useEffect(() => {
    if (!canvas) return;
    const listener = hasObjects;
    canvas.on('canvas:cleared', listener);
    canvas.on('object:history:add', listener);
    canvas.on('object:history:remove', listener);
    return () => {
      canvas.off('canvas:cleared', listener);
      canvas.off('object:history:add', listener);
      canvas.off('object:history:remove', listener);
    };
  }, [canvas, hasObjects]);
  return has;
}
